import { Box } from '@mui/material';
import useIsUserPremium from '@/DesignSystem/hooks/useIsUserPremium';
import useIsProduction from '@/DesignSystem/hooks/useIsProduction';

// TODO: Implement the placement modal component

const PlacementModalComponent = () => {
    const isPremium = useIsUserPremium();
    const isProduction = useIsProduction();

    if (isPremium || !isProduction) return null;

    return <></>;
};

export default PlacementModalComponent;
